import { css } from "@linaria/core";
import cx from "classnames";
import React, { memo } from "react";
import { EqualizerLine } from "@ui/IconV2/react";
import Popper from "@ui/Popper";
import { colors, shadows } from "@ui/Theme";
import ButtonIconV2 from "@ui/ButtonIconV2";
import TooltipV2 from "@ui/TooltipV2";

const MenuToggle = css`
  position: relative;
  padding: 0;
  height: 32px;
  width: 32px;
  flex-shrink: 0;
`;

const Marker = css`
  position: relative;
  &::after {
    background-color: ${colors.lightNitrogen500_Main};
    border-radius: 8px;
    border: 1px solid ${colors.hydrogen};
    content: "";
    display: block;
    height: 10px;
    width: 10px;
    position: absolute;
    right: 0px;
    top: -2px;
    transform: scale(0);
    transition: transform 100ms cubic-bezier(0.64, 0.57, 0.67, 1.53);
  }

  &.marker::after {
    transform: scale(1);
  }
`;

const Menu = css`
  background-color: ${colors.hydrogen};
  border-radius: 8px;
  box-shadow: ${shadows.shadow100};
  display: grid;
  padding: 16px;
  gap: 8px;
  max-width: 360px;
`;

export const ChartMenu = memo(
  ({
    marker,
    tooltipOverlay,
    children,
    className,
  }: React.PropsWithChildren<{
    marker?: boolean;
    tooltipOverlay?: string;
    className?: string;
  }>) => (
    <Popper
      click
      gap={4}
      placement="bottom-end"
      backgroundColor="transparent"
      overlay={<div className={Menu}>{children}</div>}
    >
      <div className={cx(Marker, { marker }, className)}>
        {tooltipOverlay && (
          <TooltipV2 overlay={tooltipOverlay}>
            <ButtonIconV2 className={cx(MenuToggle, { marker })}>
              <EqualizerLine size="m" />
            </ButtonIconV2>
          </TooltipV2>
        )}
        {!tooltipOverlay && (
          <ButtonIconV2 className={cx(MenuToggle, { marker })}>
            <EqualizerLine size="m" />
          </ButtonIconV2>
        )}
      </div>
    </Popper>
  ),
);
